import { createAsyncThunk } from '@reduxjs/toolkit';

export const retrieveAllPlanning = createAsyncThunk(
	'[PLANNING] retrieveAllPlanning',
	async (options, thunk: { extra: any }) => {
		return await thunk.extra.planningService.getAll(options);
	}
);
